<template>
    <vx-box-glass active>
        <home-slider :autoPlay="false">
            <div
                v-if="onCorporate()"
                class="grid @xl:grid-cols-[.4fr_.6fr] gap-6 p-8 @xl:flex-row @xl:pb-0"
            >
                <div class="@2xl:shrink-[1.2] @xl:pb-24">
                    <h2 class="text-xl font-extrabold">New Hubspot App</h2>
                    <p class="mb-2 mt-2 text-sm text-slate-500">
                        Bring your HubSpot workflows to life with personalized
                        SMS conversations that cut through the noise.
                    </p>
                    <vx-button href="https://explore.voxie.com/voxie-hubspot" rel="noopener" target="_blank" >
                        Learn More
                        <font-awesome-icon
                            widthAuto
                            :icon="faSquareArrowUpRight"
                        ></font-awesome-icon>
                    </vx-button>
                </div>

                <div class="relative @xl:pb-8 flex items-end justify-end">
                    <button
                        @click="hubspotIntro = true"
                        role="button"
                        class="group/intro-video m-0 p-0 relative bg-transparent w-full max-w-[511px]"
                    >
                        <img
                            src="https://res.cloudinary.com/dsztk6f59/image/upload/w_405,dpr_2,f_auto/v1762539680/hubspot-hero-251107_z0mcle.png"
                            alt="Hubspot Demo Video Screenshot"
                            class="rounded-xl w-full aspect-v aspect-1022/593 object-cover"
                        />
                        <font-awesome-icon
                            widthAuto
                            :icon="faCirclePlay"
                            class="absolute inset-0 m-auto h-auto! w-12! text-sky-400 group-hover/intro-video:text-sky-500 transition"
                        />
                    </button>
                </div>
            </div>

            <div
                class="grid @xl:grid-cols-[.4fr_.6fr] gap-6 p-8 @xl:flex-row @xl:pb-0"
            >
                <div class="@2xl:shrink-[1.2] @xl:pb-24">
                    <h2 class="text-xl font-extrabold">
                        Mobile. Sleek. Powerful.
                    </h2>
                    <ul
                        class="list-disc list-inside text-slate-500 text-sm mt-2"
                    >
                        <li>All features, now mobile</li>
                        <li>Sleeker, simpler design</li>
                        <li>Enhanced performance</li>
                    </ul>
                    <p class="mb-4 mt-2 text-sm text-slate-500">
                        The new Voxie mobile app is here!
                    </p>
                    <vx-button type="button" @click="mobileAppIntro = true">
                        Watch Overview
                        <font-awesome-icon
                            widthAuto
                            :icon="faCirclePlay"
                        ></font-awesome-icon>
                    </vx-button>
                </div>

                <div class="relative @xl:pb-8 flex items-end justify-end">
                    <button
                        @click="mobileAppIntro = true"
                        role="button"
                        class="group/intro-video m-0 p-0 relative bg-transparent w-full max-w-[511px]"
                    >
                        <img
                            src="https://res.cloudinary.com/dsztk6f59/image/upload/w_405,dpr_2,f_auto/v1745426764/mobile_app_announcement_phzpgr.png"
                            alt="Quick Blast Demo Video Screenshot"
                            class="rounded-xl w-full aspect-1022/593"
                        />
                        <font-awesome-icon
                            widthAuto
                            :icon="faCirclePlay"
                            class="absolute inset-0 m-auto h-auto! w-12! text-sky-400 group-hover/intro-video:text-sky-500 transition"
                        />
                    </button>
                </div>
            </div>

            <div
                class="grid @xl:grid-cols-[.4fr_.6fr] gap-6 p-8 @xl:flex-row @xl:pb-0"
            >
                <div class="@2xl:shrink-[1.2] @xl:pb-24">
                    <h2 class="text-xl font-extrabold">Platform Overview</h2>
                    <p class="mb-4 mt-2 text-sm text-slate-500">
                        A tour of the Voxie application where you'll learn about
                        quick blast, message hub, campaigns, snippets, and the
                        help&nbsp;center.
                    </p>
                    <vx-button type="button" @click="overview = true">
                        Watch Overview
                        <font-awesome-icon
                            widthAuto
                            :icon="faCirclePlay"
                        ></font-awesome-icon>
                    </vx-button>
                </div>

                <div class="relative @xl:pb-8 flex items-end justify-end">
                    <button
                        @click="overview = true"
                        role="button"
                        class="group/intro-video m-0 p-0 relative bg-transparent w-full max-w-[511px]"
                    >
                        <img
                            src="https://res.cloudinary.com/dsztk6f59/image/upload/w_511,dpr_2.0,f_auto/v1737581416/platform-overview-image_j5jg0e.png"
                            alt="Quick Blast Demo Video Screenshot"
                            class="rounded-xl w-full aspect-1022/593"
                        />
                        <font-awesome-icon
                            widthAuto
                            :icon="faCirclePlay"
                            class="absolute inset-0 m-auto h-auto! w-12! text-sky-400 group-hover/intro-video:text-sky-500 transition"
                        />
                    </button>
                </div>
            </div>

            <div
                class="grid @xl:grid-cols-[.4fr_.6fr] gap-6 p-8 @xl:flex-row @xl:pb-0"
            >
                <div class="@2xl:shrink-[1.2] @xl:pb-24">
                    <h2 class="text-xl font-extrabold">Chrome Extension</h2>
                    <p class="mb-4 mt-2 text-sm text-slate-500">
                        The Voxie Chrome Extension lets you click any phone
                        number in Chrome to start a Message Hub chat—saving time
                        without opening Voxie.
                    </p>
                    <vx-button
                        type="button"
                        href="https://chromewebstore.google.com/detail/voxie/ldhfpgdknmodmhmkcdadagdmflfckldp?hl=en"
                        rel="noopener noreferrer"
                        target="_blank"
                    >
                        Get the Extension
                        <font-awesome-icon
                            widthAuto
                            :icon="faUpRightFromSquare"
                        ></font-awesome-icon>
                    </vx-button>
                </div>

                <div class="relative @xl:pb-8 flex items-end justify-end">
                    <a
                        href="https://chromewebstore.google.com/detail/voxie/ldhfpgdknmodmhmkcdadagdmflfckldp?hl=en"
                        rel="noopener noreferrer"
                        target="_blank"
                        class="group/intro-video m-0 p-0 relative bg-transparent w-full max-w-[511px]"
                    >
                        <img
                            src="https://res.cloudinary.com/dsztk6f59/image/upload/ar_16:9,c_crop/w_511,dpr_2.0,f_auto/v1737581577/browser-extension-image_p0n16g.png"
                            alt="Quick Blast Demo Video Screenshot"
                            class="rounded-xl w-full aspect-1022/593"
                        />
                    </a>
                </div>
            </div>

            <div
                v-if="!onCorporate()"
                class="grid @xl:grid-cols-[.4fr_.6fr] gap-6 p-8 @xl:flex-row @xl:pb-0"
            >
                <div class="@2xl:shrink-[1.2] @xl:pb-24">
                    <h2 class="text-xl font-extrabold">
                        Introducing Quick&nbsp;Blast
                    </h2>
                    <p class="mb-4 mt-2 text-sm text-slate-500">
                        The fastest way to send a single message to multiple
                        people. This intro video will get you generating
                        results&nbsp;today!
                    </p>
                    <vx-button type="button" @click="tutorial = true">
                        Watch Tutorial
                        <font-awesome-icon
                            widthAuto
                            :icon="faCirclePlay"
                        ></font-awesome-icon>
                    </vx-button>
                </div>

                <div class="relative @xl:pb-8 flex items-end justify-end">
                    <button
                        @click="tutorial = true"
                        role="button"
                        class="group/intro-video m-0 p-0 relative bg-transparent w-full max-w-[511px]"
                    >
                        <img
                            src="https://res.cloudinary.com/dsztk6f59/image/upload/w_511,dpr_2.0,f_auto/v1720812036/quickblast-preview_nwwgvr.jpg"
                            alt="Quick Blast Demo Video Screenshot"
                            class="rounded-xl w-full aspect-1022/593"
                        />
                        <font-awesome-icon
                            widthAuto
                            :icon="faCirclePlay"
                            class="absolute inset-0 m-auto h-auto! w-12! text-sky-400 group-hover/intro-video:text-sky-500 transition"
                        />
                    </button>
                </div>
            </div>

            <div
                v-if="onCorporate()"
                class="flex flex-col justify-between p-8 pb-0 @xl:flex-row"
            >
                <div class="@xl:pb-24">
                    <h2 class="text-xl font-extrabold">Expand Your Reach</h2>
                    <p class="mb-4 mt-2 text-sm text-slate-500">
                        Did you know you can significantly increase your reach
                        by simply adding our contact collector to
                        your&nbsp;website?
                    </p>
                    <vx-button href="/settings/integrations#/contact-collector">
                        Connect Your Website
                        <font-awesome-icon widthAuto :icon="faArrowRight" />
                    </vx-button>
                </div>
                <div
                    class="-mx-3 overflow-hidden flex items-end justify-end @xl:-ml-24 @xl:w-[330px] @2xl:w-[400px] @xl:shrink-0 -z-10"
                >
                    <img
                        src="https://res.cloudinary.com/dsztk6f59/image/upload/w_535,dpr_2.0,f_auto/v1721143202/reach_art_b5qxvy.png"
                        alt="paper airplane graphic"
                        class="mb-12 @sm:mb-8 @md:mb-0 @xl:-mb-8 w-full max-w-[535px] aspect-1070/676"
                    />
                </div>
            </div>
        </home-slider>
    </vx-box-glass>
    <vx-modal
        v-model:visible="tutorial"
        :padding="false"
        class="max-w-[1200px] p-4 sm:p-10"
    >
        <template v-slot:header>
            <div class="mb-4">Quick Blast Introduction</div>
        </template>
        <iframe
            src="https://www.loom.com/embed/3551f9676b3a4af980469a96d1b7899b?hideEmbedTopBar=true&autoplay=true"
            frameborder="0"
            class="w-full h-full block rounded-xl aspect-video"
        >
        </iframe>
    </vx-modal>
    <vx-modal
        v-model:visible="overview"
        :padding="false"
        class="max-w-[1200px] p-4 sm:p-10"
    >
        <template v-slot:header>
            <div class="mb-4">Platform Overview</div>
        </template>
        <iframe
            src="https://www.loom.com/embed/bd255f71843c490db81a0bd8c2e3dbf7?hideEmbedTopBar=true&autoplay=false"
            frameborder="0"
            class="w-full h-full block rounded-xl aspect-video"
        >
        </iframe>
    </vx-modal>
    <vx-modal
        v-model:visible="mobileAppIntro"
        :padding="false"
        class="max-w-[1200px] p-4 sm:p-10"
    >
        <template v-slot:header>
            <div class="mb-4">Mobile App Overview</div>
        </template>
        <iframe
            src="https://www.loom.com/embed/697c3b518db24e8a84d0c097d0aa7d3e?hideEmbedTopBar=true&autoplay=false"
            frameborder="0"
            class="w-full h-full block rounded-xl aspect-video"
        >
        </iframe>
    </vx-modal>
    <vx-modal
        v-model:visible="hubspotIntro"
        :padding="false"
        class="max-w-[1200px] p-4 sm:p-10"
    >
        <template v-slot:header>
            <div class="mb-4">New Hubspot App</div>
        </template>
        <iframe
            src="https://www.loom.com/embed/78ae820d996848d1b981f990d9edcce6?hideEmbedTopBar=true&autoplay=false"
            frameborder="0"
            class="w-full h-full block rounded-xl aspect-video"
        >
        </iframe>
    </vx-modal>
</template>

<script setup>
import { VxBoxGlass, VxButton, VxModal } from '@voxie/frontend-components';
import { ref } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
    faCirclePlay,
    faArrowRight,
    faUpRightFromSquare,
    faSquareArrowUpRight,
} from '@fortawesome/pro-solid-svg-icons';
import HomeSlider from './HomeSlider.vue';
import { useCurrentGroup } from '~/composables/useCurrentGroup';

const tutorial = ref(false);
const overview = ref(false);
const mobileAppIntro = ref(false);
const hubspotIntro = ref(false)
const { onCorporate } = useCurrentGroup();
</script>
